import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const page = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["6x"],
  minWidth: 0,
  flex: 1
});

export const header = style({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "flex-end",
  justifyContent: "space-between",
  gap: primitiveTokens.sizing["4x"]
});

export const title = style({
  margin: 0,
  fontSize: primitiveTokens.type.xl,
  fontWeight: 400,
  lineHeight: 1.2
});

export const description = style({
  margin: `${primitiveTokens.sizing["1x"]} 0 0`,
  maxWidth: "720px",
  fontSize: primitiveTokens.type.sm,
  color: semanticThemeTokens.label.color.regular
});

export const loadError = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["3x"]
});

// Centred below the header; the wrapper keeps the spinner unstretched.
export const spinner = style({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
